import ReactDOM from 'react-dom'
import './styles.css'
import App from './App'

ReactDOM.render(<App position="relative" />, document.getElementById('root'))
